import { ModalWrapper } from '@/core/modal';
import { useTracker } from '@/core/tracking';
import { useLocalization } from '@/services/localizationService';
import { closeModalSelector } from '@/stores/modalStore';
import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';

export default function ResetFormatModal({
  id,
  overwriteAllFormats,
  ...rest
}: {
  id: string;
  overwriteAllFormats: () => void;
}) {
  const closeModal = useSetRecoilState(closeModalSelector);
  const { t, data } = useLocalization();
  const { track } = useTracker();

  useEffect(() => {
    track('overwrite_all_formats_modal', 'shown');
  }, [track]);

  return (
    <ModalWrapper className="text-center relative w-80" {...rest}>
      <p className="SB20 text-black my-2">
        {t(data.result.multipleFormatsAlertTitle)}
      </p>

      <p className="M16 text-gray-450 mt-3 mx-1">
        {t(data.result.multipleFormatsAlertBody)}
      </p>
      <button
        type="button"
        className="w-11/12 btn btn--large shadow-dark-button btn--black mt-7 inline-flex"
        onClick={() => {
          track('overwrite_all_formats_modal', 'accepted');
          closeModal(id);
          overwriteAllFormats();
        }}
      >
        <span className="SB16">{t(data.result.overwriteAll)}</span>
      </button>
      <button
        type="button"
        className="SB16 text-black mt-5 mb-2"
        onClick={() => {
          track('overwrite_all_formats_modal', 'not_accepted');
          closeModal(id);
        }}
      >
        {t(data.common.cancel)}
      </button>
    </ModalWrapper>
  );
}
